import { handleApiPostRequest, handleApiGetRequest } from './utils';

export async function admin_login(email, password) {
    return await handleApiPostRequest('admin-login/', {
        action: 'admin-login',
        email: email,
        password: password
    });
}

export async function save_new_permission(token, data) {
    return await handleApiPostRequest('admin/', {
        action: 'save_new_permission',
        admin_auth_token: token,
        category: data.category,
        name: data.name,
        scope: data.scope,
        description: data.description
    });
}

export async function update_permission(token, data) {
    return await handleApiPostRequest('admin/', {
        action: 'update_permission',
        admin_auth_token: token,
        id: data.permission_id,
        category: data.category,
        name: data.name,
        scope: data.scope,
        description: data.description
    });
}

export async function update_permissions_order(token, data) {
    return await handleApiPostRequest('admin/', {
        action: 'update_permissions_order',
        admin_auth_token: token,
        permissions_order: data
    });
}

export async function get_all_permissions(token) {
    return await handleApiGetRequest(`admin/`, {
        action: "get_permissions",
        admin_auth_token: token
    });
}

export async function get_sessions(token, model_id) {
    return await handleApiGetRequest('admin/', {
        action: 'get-sessions',
        admin_auth_token: token,
        model_id: model_id
    });
}

export async function scraping_status(token, model_id, date_from, date_to) {
    return await handleApiGetRequest('admin/', {
        action: 'scraping-status',
        admin_auth_token: token,
        model_id: model_id,
        date_from: date_from,
        date_to: date_to
    });
}

export async function fetchEmployeeUserToken(token, employee_id) {
    return await handleApiGetRequest('admin/', {
        action: 'fetch-employee-user-token',
        admin_auth_token: token,
        employee_id: employee_id
    });
}

export async function mark_invoice_paid(token, invoice_id) {
    return await handleApiPostRequest('admin/', {
        action: 'mark-invoice-paid',
        admin_auth_token: token,
        invoice_id: invoice_id
    });
}

export async function scrape_data(token, model_id, date) {
    return await handleApiGetRequest('admin/', {
        action: 'scrape-data',
        admin_auth_token: token,
        model_id: model_id,
        date: date
    });
}

export async function get_invoices(token, company_id) {
    return await handleApiGetRequest('admin/', {
        action: 'get-invoices',
        company_id: company_id,
        admin_auth_token: token
    });
}

export async function get_invoice_detail(token, invoice_id) {
    return await handleApiGetRequest('admin/', {
        action: 'get-invoice-detail',
        invoice_id: invoice_id,
        admin_auth_token: token
    });
}

export async function validate_admin_token(token) {
    return await handleApiPostRequest('admin-login/', {
        action: 'validate-admin-token',
        admin_auth_token: token
    });
}

export async function getAnalytics(token, analytics_type) {
    return await handleApiGetRequest('admin/', {
        action: 'get-analytics',
        admin_auth_token: token,
        analytics_type: analytics_type
    });
}

export async function getAgencies(token) {
    return await handleApiGetRequest('admin/', {
        action: 'get-agencies',
        admin_auth_token: token
    });
}

export async function getCreators(token, company_id) {
    return await handleApiGetRequest('admin/', {
        action: 'get-creators',
        company_id: company_id,
        admin_auth_token: token
    });
}

export async function getEmployees(token, company_id) {
    return await handleApiGetRequest('admin/', {
        action: 'get-employees',
        company_id: company_id,
        admin_auth_token: token
    });
}

export async function getCompanies(token) {
    return await handleApiGetRequest('admin/', {
        action: 'get-companies',
        admin_auth_token: token
    });
}